import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AuthCallback() {
  const navigate = useNavigate();
  const { login } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash;
    const sessionId = new URLSearchParams(hash.substring(1)).get('session_id');

    if (!sessionId) {
      navigate('/login', { replace: true });
      return;
    }

    (async () => {
      try {
        const res = await axios.post(`${API}/auth/google/callback`, { session_id: sessionId });
        const { token, user, is_first_login } = res.data;
        login(token, user, is_first_login);
        navigate('/dashboard', { replace: true, state: { isFirstLogin: is_first_login } });
      } catch (err) {
        console.error('Google auth failed:', err);
        navigate('/login', { replace: true });
      }
    })();
  }, [login, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center" style={{ background: '#f5f0eb' }}>
      <div className="animate-pulse text-[#a3b6a0] font-heading text-xl">Signing you in...</div>
    </div>
  );
}
